import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const listTeamAppsTE = <E = CF.API.ApiError>(
  { orgId, teamId, params = '' }: { orgId: string; teamId: string; params?: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Organizations.ListTeamAppsResponse> =>
  fetchTE<CF.API.Organizations.ListTeamAppsResponse, E>(
    {
      path: `/api/_api/v2/organizations/${orgId}/teams/${teamId}/apps${params ? `?${params}` : ''}`,
      method: 'GET',
    },
    onRejected,
  );
